import { render } from "./Situation.vue?vue&type=template&id=f223323c&scoped=true&ts=true"
import script from "./Situation.vue?vue&type=script&lang=ts"
export * from "./Situation.vue?vue&type=script&lang=ts"

import "./Situation.vue?vue&type=style&index=0&id=f223323c&lang=scss&scoped=true"

import exportComponent from "/var/www/html/drupal/modules/custom/nvschade_calculator/assets/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f223323c"]])

export default __exports__